import React, { memo, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Fade } from 'react-reveal'
import toast from 'react-hot-toast';
import { selectorQuiz } from '../../../features/quiz/quizSlice';
import questionnaire from '../../../questionnaire'
import { FormCard } from '../../FormCard';
import Checkbox from '../Checkbox';
import Footer from '../Footer';
import MultipleChoice from '../MultipleChoice';
import QCMLabel from '../QCMLabel';
import StepWizard from 'react-step-wizard';
import SubNav from '../SubNav';
import ToastAction from '../../ToastAction';
import { api } from '../../../api';
import { checkElement, getConformSelector } from '../../../utils';

const { section4 } = questionnaire

const { question10, question11, question12, question13, question14, question15, question16, question17, question18, question19 } = section4.questions

const mapQuestionsIds = {}

question10.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})
question11.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question12.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question13.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question15.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question16.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question18.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

question19.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

function Step3(props) {
  const [instance, updateInstance] = useState();
  const setInstance = SW => updateInstance(SW);
  const quiz = useSelector(selectorQuiz)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)

  useEffect(() => {
    checkElement(`#${mapQuestionsIds[quiz.question10]}-choice_question10`)
    checkElement(`#${mapQuestionsIds[quiz.question11]}-choice_question11`)
    checkElement(`#${mapQuestionsIds[quiz.question12]}-choice_question12`)
    checkElement(`#${mapQuestionsIds[quiz.question13]}-choice_question13`)
    checkElement(`#${mapQuestionsIds[quiz.question15]}-choice_question15`)
    checkElement(`#${mapQuestionsIds[quiz.question16]}-choice_question16`)
    checkElement(`#${mapQuestionsIds[quiz.question18]}-choice_question18`)
    checkElement(`#${mapQuestionsIds[quiz.question19]}-choice_question19`)
  }, [])

  useEffect(() => {
    props.firstStep()
  }, [activeWebsite])

  const onSubmit = useCallback(async (e) => {
    e.preventDefault()

    if (!quiz.question10) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question10 requise !" description="Veuillez selectionner un choix sur la question10." />)
    if (!quiz.question11) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question11 requise !" description="Veuillez selectionner un choix sur la question11." />)

    if (instance.currentStep == 2) {
      if (!quiz.question12) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question12 requise !" description="Veuillez selectionner un choix sur la question12." />)
      if (!quiz.question13) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question13 requise !" description="Veuillez selectionner un choix sur la question13." />)
    }

    if (instance.currentStep == 3) {
      if (!quiz.question14.length) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question14 requise !" description="Veuillez selectionner un choix sur la question14." />)
      if (quiz.question14.length > 0 && !quiz.question14.includes(question14.options.at(-1).value) && !quiz.question15) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question15 requise !" description="Veuillez selectionner un choix sur la question15." />)
      if (!quiz.question16) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question16 requise !" description="Veuillez selectionner un choix sur la question16." />)
    }

    if (instance.currentStep == 4) {
      if (!quiz.question17.length) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question17 requise !" description="Veuillez selectionner un choix sur la question17." />)
      if (quiz.question17.length > 0 && !quiz.question17.includes(question14.options.at(-1).value) && !quiz.question18) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question18 requise !" description="Veuillez selectionner un choix sur la question18." />)
      if (!quiz.question19) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question19 requise !" description="Veuillez selectionner un choix sur la question19." />)
    }

    if (instance && instance.currentStep < instance.totalSteps) {
      window.scrollTo(0, 0)
      instance.nextStep()
    } else {
      const idLoading = toast.loading("Enregistrement en cours...")
      try {
        const quizz = { ...quiz }
        delete quizz.loading
        await api.sites().update({ website_id: activeWebsite.id, quizz })
        toast.dismiss(idLoading)
        toast.custom((t) => <ToastAction saraExpression="thumb_up" toastRef={t} label="Félicitations !" description="J'ai bien enregistré vos réponses, merci !" />)
        props.firstStep()
      } catch (error) {
        console.log(error);
        toast.dismiss(idLoading)
        toast.custom((t) => <ToastAction saraExpression="sorry" toastRef={t} label="Oups !!" description="Nous avons rencontré un problème. Veuillez réessayer SVP !" />)
      }
    }
  }, [quiz, instance])

  return (
    <form onSubmit={onSubmit}>
      <section className={`section-questions`}>
        <FormCard title='STRATEGIE DIGITALE'>
          <StepWizard instance={setInstance} nav={<SubNav />}>
            <Step31 question10={question10} question11={question11} />
            <Step32 question12={question12} question13={question13} />
            <Step33 quiz={quiz} question14={question14} question15={question15} question16={question16} />
            <Step34 quiz={quiz} question17={question17} question18={question18} question19={question19} />
          </StepWizard>
        </FormCard>
      </section>
      {(instance) && <Footer previousStep={instance.currentStep > 1 ? instance.previousStep : props.previousStep} nextStep={instance.nextStep} totalSteps={instance.totalSteps} currentStep={instance.currentStep} disabled={true} />}
    </form>
  )
}

const Step31 = ({ question10, question11 }) => {

  return (
    <>
      <div className='mb-10'>
        <h4 className='question'>{question10.label}</h4>
        {question10.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question10' idEl={mapQuestionsIds[answer]} />)}
      </div>
      <div className='mb-10'>
        <h4 className='question'>{question11.label}</h4>
        {question11.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question11' idEl={mapQuestionsIds[answer]} />)}
      </div>
    </>
  )
}

const Step32 = ({ question12, question13 }) => {

  return (
    <>
      <div className='mb-10'>
        <h4 className='question'>{question12.label}</h4>
        {question12.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question12' idEl={mapQuestionsIds[answer]} />)}
      </div>
      <div className='mb-10'>
        <h4 className='question'>{question13.label}</h4>
        {question13.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question13' idEl={mapQuestionsIds[answer]} />)}
      </div>
    </>
  )
}

const Step33 = ({ question14, question15, question16, quiz }) => {

  return (
    <>
      <div>
        <QCMLabel label={question14.label} />
        <MultipleChoice options={question14.options} defaultValue={quiz.question14} questionNumber='choice_question14' />
      </div>
      {quiz.question14 && quiz.question14.length > 0 && !quiz.question14.includes(question14.options.at(-1).value) && <Fade>
        <div className='mb-10'>
          <h4 className='question'>{question15.label}</h4>
          {question15.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question15' idEl={mapQuestionsIds[answer]} />)}
        </div>
      </Fade>
      }
      <div className='mb-10'>
        <h4 className='question'>{question16.label}</h4>
        {question16.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question16' idEl={mapQuestionsIds[answer]} />)}
      </div>
    </>
  )
}

const Step34 = ({ question17, question18, question19, quiz }) => {

  return (
    <>
      <div>
        <QCMLabel label={question17.label} />
        <MultipleChoice options={question17.options} defaultValue={quiz.question17} questionNumber='choice_question17' />
      </div>
      {quiz.question17 && quiz.question17.length > 0 && <Fade>
        <div className='mb-10'>
          <h4 className='question'>{question18.label}</h4>
          {question18.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question18' idEl={mapQuestionsIds[answer]} />)}
        </div>
      </Fade>
      }
      <div className='mb-10'>
        <h4 className='question'>{question19.label}</h4>
        {question19.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question19' idEl={mapQuestionsIds[answer]} />)}
      </div>
    </>
  )
}

export default memo(Step3)